// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useAuthUser } from "react-auth-kit";
import {
  // Grid,
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import usePageTitle from "app/pageTitle";

function UserProfile() {
  const title = "My Profile";
  usePageTitle(title);

  const auth = useAuthUser();
  const accountInfo = auth();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={1.5} pb={3} mb={3}>
        {accountInfo === null ? (
          <> </>
        ) : (
          <MDBox>
            <Card sx={{ width: "100%", marginTop: "10px" }}>
              <MDBox mt={1}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    User Information
                  </MDTypography>
                </MDBox>
                <TableContainer component={Paper}>
                  <Table aria-label="personal information">
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Last Name
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.user.last_name}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Other Names
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.user.first_name}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Email Address
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.user.email_address}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Phone Number
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.user.phone_number}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Role
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.role.title}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserProfile;
